var e = class e2 extends HTMLElement {
  constructor() {
    super(), this.onActiveFilterClick = this.onActiveFilterClick.bind(this), this.debouncedOnSubmit = debounce((e4) => {
      this.onSubmitHandler(e4);
    }, 800), this.querySelector(`form`).addEventListener(`input`, this.debouncedOnSubmit.bind(this));
    let e3 = this.querySelector(`#FacetsWrapperDesktop`);
    e3 && e3.addEventListener(`keyup`, onKeyUpEscape);
  }
  static setListeners() {
    window.addEventListener(`popstate`, (t2) => {
      let n2 = t2.state ? t2.state.searchParams : e2.searchParamsInitial;
      n2 !== e2.searchParamsPrev && e2.renderPage(n2, null, false);
    });
  }
  static toggleActiveFacets(e3 = true) {
    document.querySelectorAll(`.js-facet-remove`).forEach((t2) => {
      t2.classList.toggle(`disabled`, e3);
    });
  }
  static renderPage(t2, n2, r = true) {
    e2.searchParamsPrev = t2;
    let i = e2.getSections(), a = document.getElementById(`ProductCount`), o = document.getElementById(`ProductCountDesktop`);
    document.querySelectorAll(`.facets-container .loading__spinner, facet-filters-form .loading__spinner`).forEach((e3) => e3.classList.remove(`hidden`)), document.getElementById(`ProductGridContainer`).querySelector(`.collection`).classList.add(`loading`), a && a.classList.add(`loading`), o && o.classList.add(`loading`), i.forEach((r2) => {
      let i2 = `${window.location.pathname}?section_id=${r2.section}&${t2}`, a2 = (e3) => e3.url === i2;
      e2.filterData.some(a2) ? e2.renderSectionFromCache(a2, n2) : e2.renderSectionFromFetch(i2, n2);
    }), r && e2.updateURLHash(t2);
  }
  static renderSectionFromFetch(t2, n2) {
    fetch(t2).then((e3) => e3.text()).then((r) => {
      let i = r;
      e2.filterData = [...e2.filterData, { html: i, url: t2 }], e2.renderFilters(i, n2), e2.renderProductGridContainer(i), e2.renderProductCount(i), typeof initializeScrollAnimationTrigger == `function` && initializeScrollAnimationTrigger(i.innerHTML);
    });
  }
  static renderSectionFromCache(t2, n2) {
    let r = e2.filterData.find(t2).html;
    e2.renderFilters(r, n2), e2.renderProductGridContainer(r), e2.renderProductCount(r), typeof initializeScrollAnimationTrigger == `function` && initializeScrollAnimationTrigger(r.innerHTML);
  }
  static renderProductGridContainer(e3) {
    document.getElementById(`ProductGridContainer`).innerHTML = new DOMParser().parseFromString(e3, `text/html`).getElementById(`ProductGridContainer`).innerHTML, document.getElementById(`ProductGridContainer`).querySelectorAll(`.scroll-trigger`).forEach((e4) => {
      e4.classList.add(`scroll-trigger--cancel`);
    });
  }
  static renderProductCount(e3) {
    let t2 = new DOMParser().parseFromString(e3, `text/html`).getElementById(`ProductCount`).innerHTML, n2 = document.getElementById(`ProductCount`), r = document.getElementById(`ProductCountDesktop`);
    n2.innerHTML = t2, n2.classList.remove(`loading`), r && (r.innerHTML = t2, r.classList.remove(`loading`)), document.querySelectorAll(`.facets-container .loading__spinner, facet-filters-form .loading__spinner`).forEach((e4) => e4.classList.add(`hidden`));
  }
  static renderFilters(t2, n2) {
    let r = new DOMParser().parseFromString(t2, `text/html`), i = r.querySelectorAll(`#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter`), a = document.querySelectorAll(`#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter`);
    Array.from(a).forEach((e3) => {
      Array.from(i).some(({ id: t3 }) => e3.id === t3) || e3.remove();
    });
    let o = (e3) => {
      let t3 = n2 ? n2.target.closest(`.js-filter`) : void 0;
      return t3 ? e3.id === t3.id : false;
    }, s = Array.from(i).filter((e3) => !o(e3)), c = Array.from(i).find(o);
    if (s.forEach((e3, t3) => {
      if (document.getElementById(e3.id)) document.getElementById(e3.id).innerHTML = e3.innerHTML;
      else {
        if (t3 > 0) {
          let { className: n3, id: r2 } = s[t3 - 1];
          if (e3.className === n3) {
            document.getElementById(r2).after(e3);
            return;
          }
        }
        e3.parentElement && document.querySelector(`#${e3.parentElement.id} .js-filter`).before(e3);
      }
    }), e2.renderActiveFacets(r), e2.renderAdditionalElements(r), c) {
      let t3 = n2.target.closest(`.js-filter`).id;
      if (t3) {
        e2.renderCounts(c, n2.target.closest(`.js-filter`)), e2.renderMobileCounts(c, document.getElementById(t3));
        let r2 = document.getElementById(t3), i2 = r2.classList.contains(`mobile-facets__details`) ? `.mobile-facets__close-button` : `.facets__summary`, a2 = r2.querySelector(i2), o2 = n2.target.getAttribute(`type`) === `text`;
        a2 && !o2 && a2.focus();
      }
    }
  }
  static renderActiveFacets(t2) {
    [`.active-facets-mobile`, `.active-facets-desktop`].forEach((e3) => {
      let n2 = t2.querySelector(e3);
      n2 && (document.querySelector(e3).innerHTML = n2.innerHTML);
    }), e2.toggleActiveFacets(false);
  }
  static renderAdditionalElements(e3) {
    [`.mobile-facets__open`, `.mobile-facets__count`, `.sorting`].forEach((t2) => {
      e3.querySelector(t2) && (document.querySelector(t2).innerHTML = e3.querySelector(t2).innerHTML);
    }), document.getElementById(`FacetFiltersFormMobile`).closest(`menu-drawer`).bindEvents();
  }
  static renderCounts(e3, t2) {
    let n2 = t2.querySelector(`.facets__summary`), r = e3.querySelector(`.facets__summary`);
    r && n2 && (n2.outerHTML = r.outerHTML);
    let i = t2.querySelector(`.facets__header`), a = e3.querySelector(`.facets__header`);
    a && i && (i.outerHTML = a.outerHTML);
    let o = t2.querySelector(`.facets-wrap`), s = e3.querySelector(`.facets-wrap`);
    s && o && (t2.querySelector(`show-more-button .label-show-more.hidden`) && s.querySelectorAll(`.facets__item.hidden`).forEach((e4) => e4.classList.replace(`hidden`, `show-more-item`)), o.outerHTML = s.outerHTML);
  }
  static renderMobileCounts(e3, t2) {
    let n2 = t2.querySelector(`.mobile-facets__list`), r = e3.querySelector(`.mobile-facets__list`);
    r && n2 && (n2.outerHTML = r.outerHTML);
  }
  static updateURLHash(e3) {
    history.pushState({ searchParams: e3 }, ``, `${window.location.pathname}${e3 && `?${e3}`}`);
  }
  static getSections() {
    return [{ section: document.getElementById(`product-grid`).dataset.id }];
  }
  createSearchParams(e3) {
    let t2 = new FormData(e3);
    return new URLSearchParams(t2).toString();
  }
  onSubmitForm(t2, n2) {
    e2.renderPage(t2, n2);
  }
  onSubmitHandler(e3) {
    e3.preventDefault();
    let t2 = document.querySelectorAll(`facet-filters-form form`);
    if (e3.srcElement.className == `mobile-facets__checkbox`) {
      let t3 = this.createSearchParams(e3.target.closest(`form`));
      this.onSubmitForm(t3, e3);
    } else {
      let n2 = [], r = e3.target.closest(`form`).id === `FacetFiltersFormMobile`;
      t2.forEach((e4) => {
        r ? e4.id === `FacetFiltersFormMobile` && n2.push(this.createSearchParams(e4)) : (e4.id === `FacetSortForm` || e4.id === `FacetFiltersForm` || e4.id === `FacetSortDrawerForm`) && n2.push(this.createSearchParams(e4));
      }), this.onSubmitForm(n2.join(`&`), e3);
    }
  }
  onActiveFilterClick(t2) {
    t2.preventDefault(), e2.toggleActiveFacets();
    let n2 = t2.currentTarget.href.indexOf(`?`) == -1 ? `` : t2.currentTarget.href.slice(t2.currentTarget.href.indexOf(`?`) + 1);
    e2.renderPage(n2);
  }
};
e.filterData = [], e.searchParamsInitial = window.location.search.slice(1), e.searchParamsPrev = window.location.search.slice(1), customElements.define(`facet-filters-form`, e), e.setListeners();
var t = class extends HTMLElement {
  constructor() {
    super(), this.querySelectorAll(`input`).forEach((e3) => {
      e3.addEventListener(`change`, this.onRangeChange.bind(this)), e3.addEventListener(`keydown`, this.onKeyDown.bind(this));
    }), this.setMinAndMaxValues();
  }
  onRangeChange(e3) {
    this.adjustToValidValues(e3.currentTarget), this.setMinAndMaxValues();
  }
  onKeyDown(e3) {
    e3.metaKey || e3.key.match(/[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/) || e3.preventDefault();
  }
  setMinAndMaxValues() {
    let e3 = this.querySelectorAll(`input`), t2 = e3[0], n2 = e3[1];
    n2.value && t2.setAttribute(`data-max`, n2.value), t2.value && n2.setAttribute(`data-min`, t2.value), t2.value === `` && n2.setAttribute(`data-min`, 0), n2.value === `` && t2.setAttribute(`data-max`, n2.getAttribute(`data-max`));
  }
  adjustToValidValues(e3) {
    let t2 = Number(e3.value), n2 = Number(e3.getAttribute(`data-min`)), r = Number(e3.getAttribute(`data-max`));
    t2 < n2 && (e3.value = n2), t2 > r && (e3.value = r);
  }
};
customElements.define(`price-range`, t);
var n = class extends HTMLElement {
  constructor() {
    super();
    let e3 = this.querySelector(`a`);
    e3.setAttribute(`role`, `button`), e3.addEventListener(`click`, this.closeFilter.bind(this)), e3.addEventListener(`keyup`, (e4) => {
      e4.preventDefault(), e4.code.toUpperCase() === `SPACE` && this.closeFilter(e4);
    });
  }
  closeFilter(e3) {
    e3.preventDefault(), (this.closest(`facet-filters-form`) || document.querySelector(`facet-filters-form`)).onActiveFilterClick(e3);
  }
};
customElements.define(`facet-remove`, n);
//# sourceMappingURL=facets.js.map
